import { render, staticRenderFns } from "./EditNotificationSocle.vue?vue&type=template&id=2c0e2f8c&"
import script from "./EditNotificationSocle.vue?vue&type=script&lang=ts&"
export * from "./EditNotificationSocle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports